export const licenseTypes = [
    {
        label: "License Days",
        value: "license_days"
    },
    {
        label: "Free Minutes",
        value: "free_min"
    },
    {
        label: "License Days",
        value: "License"
    },
];